/**
 * @fileoverview POST handler for the "/engagement/:app_group_id/compiled_iam_custom_css" endpoint
 */
import fetch from "@lib/fetch";

import { reactQueryMutationAdapter } from "../reactQueryFetcherAdapters";
import { engagementAppGroupIdCompiledIamCustomCssCacheKeys } from "./constants";
import type { PostEngagementAppGroupIdCompiledIamCustomCssProps, CompileIamCustomCssResult } from "./types";

export const postCompiledIamCustomCss = reactQueryMutationAdapter(
  engagementAppGroupIdCompiledIamCustomCssCacheKeys,
  (props: PostEngagementAppGroupIdCompiledIamCustomCssProps): Promise<CompileIamCustomCssResult> => {
    return fetch(`/engagement/${props.appGroupId}/compiled_iam_custom_css`, "POST", props);
  }
);
